export default {
    intro: `Hãy đọc kỹ đoạn văn và giải câu đố của Mèo Đố Vui nhé.<br/>
            Làm xong hết sẽ có món ăn vặt ngon đang chờ bạn!`,
    next: 'Tiếp theo',
};
